import { MutationTree } from "vuex"
import { FacebookState } from "."

export const mutations: MutationTree<FacebookState> = {
  setCampaigns(state, campaigns: []) {
    state.campaigns = campaigns;
  },
  setImages(state, images = []) {
    state.adimages = images;
  },
  resetImages(state) {
    state.selectedAdimages = [];
  },
  selectAdImage(state, i) {
    if (state.selectedAdimages.find(({ id: _id }) => _id === i.id)) {
      return;
    }

    // eslint-disable-next-line @typescript-eslint/camelcase
    // c.adsets.data[0].targeting.custom_audiences = [];

    state.selectedAdimages = [
      ...state.selectedAdimages,
      JSON.parse(JSON.stringify(i))
    ];
  },
  unSelectCampaign(state, i) {
    state.selectedAdimages = state.selectedAdimages.filter(
      ({ id: _id }) => _id !== i.id
    );
  },
  resetCampaigns(state) {
    state.selectedCampaigns = [];
  },
  selectCampaign(state, c) {
    // handle duplicates
    if (state.selectedCampaigns.find(({ id: _id }) => _id === c.id)) {
      return;
    }

    // eslint-disable-next-line @typescript-eslint/camelcase
    c.adsets.data[0].targeting.custom_audiences = [];

    state.selectedCampaigns = [
      ...state.selectedCampaigns,
      JSON.parse(JSON.stringify(c))
    ];
  },
  unSelectAdImage(state, c) {
    state.selectedAdimages = state.selectedAdimages.filter(
      ({ id: _id }) => _id !== c.id
    );
  },
  unSelectAllCampaign(state) {
    state.selectedCampaigns = [];
  },
  setAdvideos(state, advideos: []) {
    state.advideos = advideos;
  },
  setAudiences(state, advideos: []) {
    state.audiences = advideos;
  },
  unSelectAdVideo(state, ad) {
    state.selectedAdvideos = state.selectedAdvideos.filter(
      ({ id: _id }) => _id !== ad.id
    );
  },
  resetAdvideos(state) {
    state.advideos = [];
  },
  resetAudiences(state) {
    state.audiences = [];
  },
  resetSelectedAdvideos(state) {
    state.selectedAdvideos = [];
  },
  selectAdvideo(state, advideo) {
    state.selectedAdvideos.push(JSON.parse(JSON.stringify(advideo)) as never);
  },
  selectThumb(
    state,
    { thumbIndex, adIndex }: { thumbIndex: number; adIndex: number }
  ) {
    state.selectedAdvideos[adIndex].selectedThumb =
      state.selectedAdvideos[adIndex].thumbnails.data[thumbIndex].uri;
  },
  requests(state, requests) {
    state.requests = requests;
  },
  accounts(state, accounts) {
    state.accounts = accounts;
  },
  auth(state, auth) {
    state.auth = auth;
  },
  addError(state, error) {
    state.errors.push(error);
  },
  removeError(state, i) {
    state.errors = state.errors.filter((e, ii) => i != ii);
  },
  setAdStatuses(state, { adId, isNew }: { adId: string; isNew: boolean }) {
    state.advideos = state.advideos.map(v =>
      v.id === adId ? { ...v, status: isNew ? "NEW" : "TESTED" } : v
    );
  }
};
